<div class="modal-main">
  <div class="icon-text-profile header d-flex flex-column justify-content-center">
    <div class="d-flex align-items-center justify-content-between px-3 pt-3">
      <div style="width: 24px;"></div> <h1 class="modal-title m-0">
        {{ "ACCOUNT_SETTINGS" | translate }}
      </h1>

      <img
        src="/assets/svg/ico-hamburger-white-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
    <div
      class="d-flex flex-column justify-content-center align-items-center card-image pointer-cursor"
    >
      <ng-container *ngIf="user?.name">
        <app-profile-picture
          [name]="user?.name"
          [userData]="user"
          [font]="'large'"
        >
        </app-profile-picture>
      </ng-container>
    </div>
  </div>
  <div class="container user-detail px-4 pt-4">
    <form [formGroup]="formGroup" class="mt-3 pt-2" (ngSubmit)="submit()">
      <div class="group-container">
        <div class="form-group rounded-top form-container">
          <mat-form-field
            appearance="fill"
            class="w-100 list-container primary-input bottom-zero padding-top-balance first pointer-cursor"
          >
            <div
              class="d-flex justify-content-between list-box"
              (click)="navigateToChangeName()"
            >
              <div class="title account-setting-label">{{ "NAME" | translate }}</div>
              <div class="selected-value ml-auto text-right col-4">
                <p>
                  <app-with-tooltip [showHelpCursor]="true">{{
                    formInstance?.name?.value
                  }}</app-with-tooltip>
                </p>
              </div>
              <div class="btn-list">
                <button
                  tabindex="-1"
                  mat-icon-button
                  type="button"
                  aria-label="name"
                  class="text-right"
                >
                  <mat-icon>arrow_forward_ios</mat-icon>
                </button>
              </div>
            </div>
            <input
              matInput
              [placeholder]="'NAME' | translate"
              formControlName="name"
              class="d-none"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="group-container">
        <div class="form-group rounded-top form-container">
          <mat-form-field
            appearance="fill"
            class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
          >
            <div
              class="d-flex justify-content-between list-box"
              (click)="navigateToChangePhoneNumber()"
            >
              <div class="title account-setting-label">{{ "PHONE_NUMBER" | translate }}</div>
              <div class="selected-value ml-auto text-right">
                <p>{{ formInstance?.phone?.value }}</p>
              </div>
              <div class="btn-list">
                <button
                  tabindex="-1"
                  mat-icon-button
                  type="button"
                  aria-label="phone"
                  class="text-right"
                >
                  <mat-icon>arrow_forward_ios</mat-icon>
                </button>
              </div>
            </div>
            <input
              matInput
              [placeholder]="'SMALL_PHONE' | translate"
              formControlName="phone"
              class="d-none"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="group-container">
        <div class="form-group rounded-top form-container">
          <mat-form-field
            appearance="fill"
            class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
          >
            <div class="d-flex justify-content-between list-box">
              <div class="title account-setting-label">{{ "ACCESS_DETAIL_EMAIL" | translate }}</div>
              <div class="email ml-auto pr-3 text-right">
                <p>{{ formInstance?.email?.value }}</p>
              </div>
            </div>
            <input
              matInput
              [placeholder]="'SMALL_EMAIL' | translate"
              formControlName="email"
              class="d-none"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="group-container">
        <div class="form-group rounded-top form-container">
          <mat-form-field
            appearance="fill"
            class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
          >
            <div
              class="d-flex justify-content-between list-box"
              (click)="navigateToChangePassword()"
            >
              <mat-label class="title account-setting-label">{{ "PASSWORD" | translate }}</mat-label>
              <div class="selected-value ml-auto text-right">
                <p>{{ formInstance?.password?.value }}</p>
              </div>
              <div class="btn-list">
                <button
                  type="button"
                  tabindex="-1"
                  mat-icon-button
                  aria-label="password"
                  class="text-right"
                >
                  <mat-icon>arrow_forward_ios</mat-icon>
                </button>
              </div>
            </div>
            <input
              matInput
              [placeholder]="'SMALL_PASSWORD' | translate"
              formControlName="password"
              class="d-none"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="group-container">
        <div
          class="form-group row form-container slide-toggle-primary middle pointer-cursor"
        >
          <div class="col-10 pt-1">
            <mat-label class="title account-setting-label">{{ "FACE_ID" | translate }}</mat-label>
          </div>
          <div class="col-2 text-right pr-1">
            <mat-slide-toggle
              class="mat-toggle"
              color="primary"
              formControlName="faceId"
              (change)="changeFaceId($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <div class="group-container">
        <div
          class="form-group row form-container slide-toggle-primary last pointer-cursor"
        >
          <div class="col-10 pt-1">
            <mat-label class="title account-setting-label">{{
              "TWO_STEP_VERIFICATION" | translate
            }}</mat-label>
          </div>
          <div class="col-2 text-right pr-1">
            <mat-slide-toggle
              class="mat-toggle"
              color="primary"
              formControlName="twoStepVerification"
              (change)="changeTwoStepVeification($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <div class="group-container">
        <div
          class="form-group row form-container slide-toggle-primary last pointer-cursor"
        >
          <div class="col-10 pt-1">
            <mat-label class="title account-setting-label">{{
              "PUSH_NOTIFICATION" | translate
            }}</mat-label>
          </div>
          <div class="col-2 text-right pr-1">
            <mat-slide-toggle
              class="mat-toggle"
              color="primary"
              formControlName="pushNotificationEnabled"
              (change)="changePushNotificationEnabled($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </div>

      <div
        class="delete-account-container d-flex justify-content-center align-items-center mt-3 pointer-cursor"
        (click)="navigateToDeleteAccount()"
      >
        <img
          src="/assets/svg/ico-close-circle-outline.svg"
          class="delete-icon mr-2"
        />
        <span class="delete-account-text">{{
          "DELETE_ACCOUNT" | translate
        }}</span>
      </div>
    </form>
  </div>
</div>
